(() => {
  if (window.ksDepartmentInitialized) return;
  window.ksDepartmentInitialized = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(scope) {
    const reveal = scope.querySelectorAll('[data-ks-reveal]:not([data-ks-reveal-ready])');
    if (!reduced.matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12 });
      reveal.forEach((element, index) => {
        element.dataset.ksRevealReady = 'true';
        element.style.setProperty('--ks-reveal-delay', `${Math.min(index % 4, 3) * 60}ms`);
        observer.observe(element);
      });
    }
    scope.querySelectorAll('[data-ks-product-rail]:not([data-ks-rail-ready])').forEach(root => {
      const track = root.querySelector('[data-ks-product-track]');
      const prev = root.querySelector('[data-ks-product-prev]');
      const next = root.querySelector('[data-ks-product-next]');
      if (!track || !prev || !next) return;
      root.dataset.ksRailReady = 'true';
      function update() {
        prev.disabled = track.scrollLeft <= 3;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
      }
      function move(direction) {
        const first = track.querySelector('.card');
        const cardWidth = first ? first.getBoundingClientRect().width : track.clientWidth * .8;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        track.scrollBy({ left: direction * (cardWidth + gap), behavior: reduced.matches ? 'auto' : 'smooth' });
      }
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
